import client from '../client'
export default {
  getPlacement: data => {
    return client.get('seller/placement/list', { params: data }).then(res => res.data);
  },
  getPlacementById: id => {
    return client.get(`seller/placement/${id}`).then(res => res.data);
  },
  getSellerConnections: data => {
    return client.get('seller/connections', { params: data }).then(res => res.data);
  },
  getSellerBrands: data => {
    return client.get('seller/brands/all/by-amazon-user-id', { params: data }).then(res => res.data);
  },
  createPlacement: data => {
    return client.post(`seller/placement/campaigns/apply/${data.placementId}`, data).then(res => res.data);
  },
}